import { useEffect } from 'react';
import { NostroGeneralContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemNostroTransaction from '../hooks/use-nostro';

const ProblemNostroGeneralContentHOC = (): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.nostro,
  );
  const { currencies: currenciesList, paymentTypes } = useAppSelector(
    (state) => state.root,
  );

  const {
    getFromAccountBalanceAction,
    getToAccountBalanceAction,
    fromBalanceIsLoading,
    fromBalanceIsFetching,
    toBalanceIsLoading,
    toBalanceIsFetching,
    fromAccountBalance,
    toAccountBalance,
  } = useProblemNostroTransaction({
    transaction,
  });

  useEffect(() => {
    if (transaction) {
      getFromAccountBalanceAction();
      getToAccountBalanceAction();
    }
  }, [transaction]);

  return (
    <NostroGeneralContent
      isLoading={
        fromBalanceIsLoading ||
        fromBalanceIsFetching ||
        toBalanceIsLoading ||
        toBalanceIsFetching
      }
      transactionInfo={transaction}
      fromAccountBalance={fromAccountBalance}
      toAccountBalance={toAccountBalance}
      currenciesList={currenciesList}
      paymentsTypes={paymentTypes?.map((item) => ({
        name: item.name,
        value: item.paymentType,
      }))}
    />
  );
};

export default ProblemNostroGeneralContentHOC;
